import React from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import VIPCard from "../../../../../components/VIPCard";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { VendorInvoiceTabs } from "../../VendorInvoiceTabs";
import { selectedVIPTab } from "../atoms/atoms";
interface Props {
  count: number;
}
export const AllUnsubmittedInvoicesCard: React.FC<Props> = ({ count }) => {
  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(selectedVIPTab);
  const userPermissions = useRecoilValue(permissionsSelector);
  const currentTabs = VendorInvoiceTabs.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const handleLink = () => {
    const url = "/vendortab/invoice/acumatica";
    history.push(url);
    const index = currentTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };
  return (
    <>
      <VIPCard
        count={count}
        duration={7}
        overCount={7}
        title={"Submitted to Acumatica"}
        onClick={handleLink}
      />
    </>
  );
};
